import {Injectable} from "@angular/core";
import {GraphQLService} from "./graphql.service";
import {HttpClient} from "@angular/common/http";
import {CartItem} from "../models/cart_item.model";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable()
export class CartItemService extends GraphQLService<CartItem> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  changeAmount(item: CartItem) {
    return this.push(`mutation { updateCartItem(id: ${item.id}, amount: ${item.amount}) { id amount product { internalId productBook { isbn title subtitle } } } }`)
  }

  removeCartItem(item: CartItem) {
    return this.push(`mutation { removeCartItem(id: ${item.id}) { status message } }`)
  }

}
